import { readXlsxFile } from "./xlsx"

export type SponsorData = {
  "企業名": string
  "企業名_2": string | null
  "形式": string
}

export async function fetchSponsors() {
  const sponsors = await readXlsxFile<SponsorData>(`/data/sponsor/協賛企業.xlsx`, "シート1")
  return sponsors
}
